import { motion } from "motion/react";

export function RoiHook() {
  return (
    <motion.div
      animate={{ opacity: 1, y: 0 }}
      className="mx-auto mb-10 max-w-3xl"
      initial={{ opacity: 0, y: -8 }}
      transition={{ duration: 0.3 }}
    >
      <div className="mb-6 text-center">
        <p className="mb-2 text-[#5a4a3a] text-sm uppercase tracking-wide dark:text-[#a89a8a]">
          The math is simple
        </p>
        <div className="flex items-center justify-center gap-6">
          <div>
            <p className="font-bold text-3xl text-red-600 line-through decoration-2 dark:text-red-400">
              $150
            </p>
            <p className="text-[#5a4a3a] text-xs dark:text-[#a89a8a]">Traditional render</p>
          </div>
          <div className="text-2xl text-[#5a4a3a] dark:text-[#a89a8a]">→</div>
          <div>
            <p className="font-bold text-3xl text-green-600 dark:text-green-400">$0.10</p>
            <p className="text-[#5a4a3a] text-xs dark:text-[#a89a8a]">Aideco render</p>
          </div>
        </div>
      </div>
    </motion.div>
  );
}
